import { render, staticRenderFns } from "./SocialsRow.vue?vue&type=template&id=8dc27b28&scoped=true"
import script from "./SocialsRow.vue?vue&type=script&lang=ts"
export * from "./SocialsRow.vue?vue&type=script&lang=ts"
import style0 from "./SocialsRow.vue?vue&type=style&index=0&id=8dc27b28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc27b28",
  null
  
)

export default component.exports